import type { FaireProductEntity } from "../../entity_types/product";

export const p_dp7jfhkvjn: FaireProductEntity = {
  token: "p_dp7jfhkvjn",
  type: "product",
  name: "Santorini Grape Velvet Skin Drink",
  brandToken: "b_o3krv3vw6u",
  brandName: "KORRES USA LTD",
  imageUrl:
    "https://cdn.faire.com/fastly/3062cf4f95dfb2797a2fa44197cf8871ea29769387d4e7605eb434ebebc3c295.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a1de6fab5ad08f2824d93c4ea84ca959c7cf51eb859f900b72928de581193f39.png",
    "https://cdn.faire.com/fastly/b03baedd05a653f1985d480ea74669cb6cc8f29fdc2ecd145dc0de81835c9bca.jpeg",
    "https://cdn.faire.com/fastly/15cdcf16a8f3f8d11b23ca2596407c7c431bc6521c6a057384082d0f2b466499.jpeg",
    "https://cdn.faire.com/fastly/cdccb4a7b907716be85eb89e103a21dac3512435d43949b24e6abe96f8445516.png",
  ],
  priceDollars: 28,
  description:
    "A multi-tasking treatment that blurs imperfections, smooths textured skin and replenishes skin with an awakened hydration. Transform and smooth skin to velvet with a single drop.\n\nKey Benefits\n - Velvet soft\n - No-shine glow\n - Blurs imperfections\n - Hydrates thirsty skin\n\nSkincare Concerns\n - Rough + Depleted Texture\n\nVelvet soft\n100% of users said this product immediately makes their skin feel baby soft.\n\nBlur imperfections\n100% of users saw an improvement in their skin imperfections after 7 days.\n\nNo-shine glow\n100% of users saw more supple, brighter and resilient skin after 3 days.\n\nHighlights\n1.01 fl oz / 30 mL. Dermatologically tested. Vegan friendly. Non-comedogenic. Silicone free. Cruelty free. Recyclable packaging.\n\nHow to Use\nApply 1-3 drops over the face and neck 2x daily, avoiding the eye area.",
  tags: [],
  msrpDollars: 56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:02:06.987Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
